"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LegacySelectInput", {
  enumerable: true,
  get: function get() {
    return _SelectInput.default;
  }
});
var _SelectInput = _interopRequireDefault(require("./SelectInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }